import styled from '@emotion/styled';
import Text from '@lightspeed/cirrus-text';
import { spacing } from '@lightspeed/cirrus-tokens/utils';

export const PoBtn = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(1)};
  cursor: pointer;
`;

export const ListingActions = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${spacing(2)};

  form {
    width: 50%;
    margin-bottom: 0;
  }
`;

export const ListingActionsBottom = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: ${spacing(2)};
`;

export const ItemsHeader = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: ${spacing(2)};
  align-items: flex-end;

  a {
    color: inherit;
  }
`;

export const ItemsHeaderTitle = styled(Text)`
  flex: 1;
`;
